import React, { FunctionComponent, useMemo } from 'react';
import { MeetingSelectProps } from './types';
import { useSelector } from 'react-redux';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingsSimplePageSelectors } from '../../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { IMeetingSimple } from '../../../../../app/resource/meeting-simple/meeting-simple.types';

export const MeetingSelect: FunctionComponent<MeetingSelectProps> = ({
  onChange,
  meetingOptions,
  className,
  style,
}) => {
  // const meetings = useSelector(meetingSimpleSelectors.selectResourceList);
  const meetingIds = useSelect(meetingsSimplePageSelectors.selectTeams);
  const meetings = useSelectWithParams(meetingSimpleSelectors.selectResourcesById, meetingIds) as IMeetingSimple[];

  const options = useMemo(() => meetingOptions ?? meetings, [meetingOptions, meetings]);

  return (
    <select onChange={(e) => onChange(e.target.value)} className={className} style={style}>
      {options.map((meeting) => (
        <option key={meeting.id} value={meeting.id}>
          {meeting.title}
        </option>
      ))}
    </select>
  );
};
